import { jsx as _jsx } from "react/jsx-runtime";
import omit from 'lodash/omit';
import { useValidationGroupable } from './useValidationGroupable';
const ValidationGroupable = (props)=>{
    useValidationGroupable(props.isDirty, props.errors, {
        idPrefix: props.idPrefix,
        customGroup: props.validationGroup
    });
    const propsToPass = omit(props, [
        'validationGroup',
        'errors',
        'isDirty',
        'idPrefix'
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ...propsToPass
    });
};
export default ValidationGroupable;
